import Select, { components } from "react-select";
import { ImageLink } from "../../constants";
import { GoSearch } from "react-icons/go";
const CustomOption = (props) => {
  const { label, image, parent } = props.data;
  const imageUrl = image ? ImageLink(image) : null;

  return (
    <components.Option {...props}>
      <div className="d-flex align-items-start gap-3">

        {image && (
          <img
            src={imageUrl}
            alt={label}
            width="20"
            height="20"
            style={{ objectFit: "cover", borderRadius: "4px" }}
          />
        )}
        <div style={{ lineHeight: "1.3" }}>
          <div style={{ fontSize: "14px", }}>
            {label}
          </div>
          {parent && (
            <div
              style={{
                fontSize: "11px",
                color: "#888",
                marginTop: "2px",
              }}
            >
              {parent}
            </div>
          )}
        </div>

      </div>
    </components.Option>
  );
};
const CustomSingleValue = (props) => {
  return (
    <components.SingleValue {...props}>
      <div className="d-flex align-items-center gap-1">
        {props.data.image && (
          <img
            src={ImageLink(props.data.image)}
            alt={props.data.label}
            width="18"
            height="18"
            style={{ objectFit: "cover", borderRadius: "4px" }}
          />
        )}
        <span style={{ fontSize: "13px" }}>{props.data.label}</span>
      </div>
    </components.SingleValue>
  );
};
const CustomPlaceholder = (props) => {
  return (
    <components.Placeholder {...props}>
      <span style={{ fontSize: "13px" }}>
        {props.children}
      </span>
    </components.Placeholder>
  );
};


const CustomControlSearch = (props) => {
  return (
    <components.Control {...props}>
      <span
        style={{
          marginLeft: "1px",
          display: "flex",
          color: "#D444ED"
        }}
      >
        <GoSearch size={16} />
      </span>

      {props.children}
    </components.Control>
  );
};

const CustomControl = (props) => {
  const { selectProps } = props;

  return (
    <components.Control {...props}>
            {selectProps.placeholderImage ? (
        <img
          src={selectProps.placeholderImage}
          width="18"
          height="18"
          style={{
            marginLeft: "8px",
            marginRight: "6px",
            borderRadius: "4px",
          }}
        />
      ) : selectProps.icon ? (
        <selectProps.icon
          size={12}
          color="#5956e9"
          style={{ marginLeft: "8px", marginRight: "6px" }}
        />
      ) : null}
      {props.children}
    </components.Control>
  );
};

const CustomSelect = ({
  name,
  options,
  value,
  placeholder,
  error,
  handleChange,
  icon,
  placeholderImage,
}) => {

  return (
    <div>
      <Select
        name={name}
        options={options}
        value={options?.find((x) => x.value === value) || null}
        onChange={(selected) =>
  handleChange({
    target: {
      name,
      value: selected?.value || "",
      categoryId: selected?.categoryId || "", 
    },
  })
}
        placeholder={placeholder}
        icon={icon}
        placeholderImage={placeholderImage}
        components={{
            Control: CustomControl,
          Option: CustomOption,
          SingleValue: CustomSingleValue,
          Placeholder: CustomPlaceholder,
        }}
        classNamePrefix="custom-select"
        styles={{
          control: (base) => ({
            ...base,
            minHeight: "38px",
            fontSize: "13px",
          }),
          valueContainer: (base) => ({
            ...base,
            padding: "2px 8px",
          }),
          input: (base) => ({
            ...base,
            fontSize: "13px",
          }),
          valueContainer: (base) => ({
    ...base,
    paddingLeft: "0px", 
  }),
        }}
      />

      {error && (
        <span className="text-danger mt-2 d-block" style={{ fontSize: "12px" }}>
          {error}
        </span>
      )}
    </div>
  );
};

export default CustomSelect;

export {CustomControlSearch}
